import { Calculation, HouseholdYear, HouseholdYearListItem, HouseholdYearProcessingStatus } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for Service Models
 */
export class HouseholdYears extends CrudApiBase<HouseholdYear, HouseholdYearListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03-rc/api/household-years";

  constructor(ajax: Ajax) {
    super(ajax);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): HouseholdYear {
    return {
    };
  }

  /**
   * Returns all the paid calculations for the given year.
   * @param year - Year for the calculations.
   * @returns Array of calculations.
   */
  public getCalculationsForYear(year?: number | null): Promise<Calculation[]> {
    return this.ajax.getJSON(`${this.baseUrl}/calculations?year=${encodeURIComponent(year ?? "")}`);
  }

  /**
   * Updates the household data in the calculation
   * @param calculation - Calculation to update.
   * @returns Updated calculation.
   */
  public updateCalculation(calculation: Calculation): Promise<Calculation> {
    return this.ajax.postJSON(`${this.baseUrl}/calculations`, calculation);
  }

  /**
   * Makes a request for updating the processing status of the household deduction.
   * @param id Identifier for the year.
   * @param processingStatus The requested new processing status of the houisehold deduction.
   */
  public requestProcessingStatusUpdate(id: string, processingStatus: HouseholdYearProcessingStatus): Promise<HouseholdYear> {
    const url = `${this.baseUrl}/${id}/processingStatus/${processingStatus}`;
    return this.ajax.postJSON(url, null);
  }

  /**
   * Downloads pdf reports for the yearly household deduction.
   */
  public downloadPdfs(id: string): Promise<Array<{bytes: string, fileName: string}>> {
    const url = `${this.baseUrl}/${id}/pdfs`;
    return this.ajax.getJSON(url);
  }
}
